/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiServiceExternalLink
 */
export interface ApiServiceExternalLink {
    /**
     * 
     * @type {number}
     * @memberof ApiServiceExternalLink
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiServiceExternalLink
     */
    link: string;
    /**
     * 
     * @type {string}
     * @memberof ApiServiceExternalLink
     */
    language: string;
}

export function ApiServiceExternalLinkFromJSON(json: any): ApiServiceExternalLink {
    return ApiServiceExternalLinkFromJSONTyped(json, false);
}

export function ApiServiceExternalLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiServiceExternalLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'link': json['link'],
        'language': json['language'],
    };
}

export function ApiServiceExternalLinkToJSON(value?: ApiServiceExternalLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'link': value.link,
        'language': value.language,
    };
}

